import React from "react";

import { KeyValueList, NoData, StringWithCopy, Time } from "@components";
import NetworkLink from "../common/NetworkLink";

interface Props {
  domain?: string;
  ip?: string;
  lastAnalysisDate?: Date;
}

const NetworkHeaderAnalysis: React.FC<Props> = ({
  domain,
  ip,
  lastAnalysisDate
}) => (
  <div className="network-threat-intel__main-header-info">
    <KeyValueList className="flex flex-gap-5">
      <KeyValueList.Item
        label="Last Analyzed: "
        value={lastAnalysisDate ? <Time time={lastAnalysisDate} /> : <NoData />}
      />
      <KeyValueList.Item
        className="flex"
        label="Domain: "
        value={
          domain ? (
            <StringWithCopy value={domain} reverse>
              <NetworkLink
                className="basic-link-element"
                path="report/infrastructure/"
              >
                {domain}
              </NetworkLink>
            </StringWithCopy>
          ) : (
            <NoData />
          )
        }
      />
      <KeyValueList.Item
        className="flex"
        label="IP: "
        value={
          ip ? (
            <StringWithCopy value={ip} reverse>
              <NetworkLink
                className="basic-link-element"
                path="report/infrastructure/"
              >
                {ip}
              </NetworkLink>
            </StringWithCopy>
          ) : (
            <NoData />
          )
        }
      />
    </KeyValueList>
  </div>
);
export default NetworkHeaderAnalysis;
